import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { AnchorDirective, CookieService, CurrencyPipe, DynamicHtmlDirective, NavigationService } from '@frontend/vanilla/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { Config, Country, Jurisdiction, PageName, ProductType, ProposedProduct } from '../../../config/appConstants';
import { UrlConstants } from '../../../config/urlConstants';
import { MessageType } from '../../../model/message.model';
import { BehaviorDataService } from '../../../service/behaviorData.service';
import { ChatService } from '../../../service/chat.service';
import { DataService } from '../../../service/data.service';
import { DepositService } from '../../../service/deposit.service';
import { EventService } from '../../../service/event.service';
import { GtmService } from '../../../service/gtm.service';
import { QuickDepositMessageService } from '../../../service/quick-deposit-message.service';
import { ResizeService } from '../../../service/resize.service';
import { UserDataService } from '../../../service/userDataService';
import { MessageComponent } from '../../../shared/components/messages/message-component';
import { ErrorCode, ErrorTemplate, INTERCHECKS_ACH_ERROR_CODES, ResponseStatus } from '../../../shared/error.constants';

@Component({
    selector: 'app-deposit-failure',
    templateUrl: './deposit-failure.component.html',
    styleUrls: ['./deposit-failure.component.scss'],
    imports: [MessageComponent, TranslateModule, CurrencyPipe, DynamicHtmlDirective, AnchorDirective],
})
export class DepositFailureComponent implements OnInit, OnDestroy {
    private navigationService = inject(NavigationService);
    public depositService = inject(DepositService);
    private gtmService = inject(GtmService);
    private userdataService = inject(UserDataService);
    private dataService = inject(DataService);
    private cookieService = inject(CookieService);
    private chatService = inject(ChatService);
    private behaviorData = inject(BehaviorDataService);
    private eventService = inject(EventService);
    private translate = inject(TranslateService);
    private resizeService = inject(ResizeService);
    private quickDepositMessageService = inject(QuickDepositMessageService);
    response: any;
    purchaseLimitsErrorCodes = ['511', '789', '790', '791', '792', '793'];
    rgLimitsErrorCodes = ['116', '117', '118', '119'];
    instrumentDepositLimitExceeded = '783';
    creditCardBlocked = '620';
    amlNetDepLimitErrorCodes = ['150', '151'];

    isDEUJurisdiction: boolean;
    IsSwedenFE: boolean;
    IsGreeceFE: boolean;
    greeceFEUsers = ['br', 'sg', 'vb'];
    isDepositAllowedOnOtherProduct: any;
    depositNotAvailableMessage: boolean = false;
    amlNetDepLimitErrorDetails: any;
    jurisdiction: any;
    kycDetails: any;
    channelId: any;
    hidechatCheck: boolean;
    validationError: any;
    error: any;
    defaultError = false;
    showAchIntercheksMessage = false;

    prorgDepLimitErrorDetails: any;
    affordibilityMonthlyNetDepLimitErrorDetails: any;
    affordibilityMonthlyGrossDepLimitErrorDetails: any;
    affordibilityYearlyGrossDepLimitErrorDetails: any;
    affordibilityYearlyNetDepLimitErrorDetails: any;
    affordibility3kMilestoneLimitErrorDetails: any;
    affordibilityMilestoneSgqGrossLimitErrorDetails: any;
    affordibilityMilestoneSelfCertGrossLimitErrorDetails: any;
    affordibilityLtmGrossLimitErrorDetails: any;
    affordibilityTUDepLimitErrorDetails: any;
    affordibility8kMilestoneLimitErrorDetails: any;
    affordibilityHardStopLimitErrorDetails: any;
    svocAffordabilityErrorDetails: any;
    belgiumAffLimitsErrorDetails: any;
    sportsLimitsErrorDetails: any;
    gamingLimitsErrorDetails: any;
    gamerscardErrorCodeDetails: any;
    creditCardBlockDetails: any;
    arcDepositDecline: any;
    doNotHonorErrorDetails: any;
    invalidCvvErrorDetails: any;
    internalErrorDetails: any;
    insufficientFundsErrorDetails: any;
    errorDetails: any;
    intensivePlayerMessage: any;
    riskPlayerMessage: any;

    CentralDepLimitsErrorDetails: any;
    cdrMessagesErrorDetails: any;
    maxLossLimitMonthlyExceededErrorDetails: any;
    svocPurchaseLimitsErrorDetails: any;
    svoctxnLimitErrorDetails: any;
    ParRiskFailureErrorDetails: any;

    productToShow: string;
    proposedProduct: string;
    isSportsPreference: boolean;
    isShowSofortCTA: boolean;
    gamingLimitsNotConfigured: boolean;
    productSelectedError: string;
    isCasinoProductError: boolean;
    isPokerProductError: boolean;
    isCasinoAndPokerProductError: boolean;
    depositLimitsUrlError: string;

    pullchatEnabled: boolean;
    depositLimit: any;
    userBalance: any;
    zendeskEnabled: boolean;
    isCountryUK: boolean;
    isUSLabel: boolean;
    hideChat: boolean;
    channelIdValue: any;
    showChatCTA: boolean;
    isPlayerLevelOne: boolean;
    ExceededCase: boolean;
    isBelgiumLimitAvailable: boolean;
    availableBelgiumLimit: any;
    maxPurchaseLimit: any;
    nextDate: any;
    sportsLimitIncreaseUrl: string;
    paymentMethod: string;
    isGamesProductSupported: boolean;
    isSportsProductSupported: boolean;
    showArcGTMEvnt: boolean;
    arcDepositBlockStatus: any;
    tempObj: { [k: string]: any } = {};
    depositInfo: any;
    showChatNotAvailable: boolean;
    isGbgVerified: boolean;
    subscriptions$: Subscription[] = [];
    moreInfoIntensePlayerLink: string;
    liveChatRiskPlayerUrl: string;
    currencyGBP: string = 'GBP';
    currencyEUR: string = 'EUR';
    frequency: any;
    customerContactURL: any;
    errorDescription: string;
    positionEvnt: string;
    labelEvnt: string;
    limitType: string;
    affordabilityQuestionaireLimit: any;
    rolling30dayLossLimitDetails: any;
    showMaxLossLimitMsg: boolean;
    affMaxLossLimitSuggestionErrorDetails: any;
    frarolling90dayLossLimitDetails: any;
    affFraRollingPeriod: string;

    constructor() {
        this.response = this.depositService.submitResponse;
        this.depositInfo = this.depositService.depositInfo;
        this.isDEUJurisdiction = false;
        this.IsSwedenFE = false;
        if (this.userdataService?.userData?.configParams) {
            this.pullchatEnabled = this.userdataService?.userData?.configParams?.pullchatEnabled === Config.YES;
            this.depositLimit = this.userdataService?.userData?.configParams?.deposit_limit_constraint;
            this.userBalance = this.userdataService?.userData?.configParams?.userBalance;
            this.zendeskEnabled = this.userdataService?.userData?.configParams?.zendeskEnabled === Config.YES;
            this.channelIdValue = this.userdataService?.userData?.userInfo?.labelInfo?.channelId;
            this.isCountryUK = this.userdataService?.userData?.userInfo?.addressInfo?.country === Country.GB;
            this.isUSLabel = this.userdataService?.userData?.userInfo?.addressInfo?.country === Country.US;
            this.isGbgVerified = this.userdataService?.userData?.configParams?.gbgVerified === Config.YES;
            this.customerContactURL = this.userdataService?.userData?.configParams?.contactUsUrl;

            const lang = this.dataService?.sessionInfo?.langId ?? 'en';
            this.liveChatRiskPlayerUrl = `${this.userdataService?.userData?.configParams?.merchant_hostname}/${lang}${UrlConstants.LIVE_CHAT_ES_LINK}`;
            this.moreInfoIntensePlayerLink = `${this.userdataService?.userData?.configParams?.merchant_hostname}/${lang}${UrlConstants.MORE_INFO_ES_LINK}`;
        }
        this.hideChat = this.dataService?.sessionInfo?.hideChat === 'true' ? true : false;
        if (!['AN', 'AW', 'IN', 'IW'].includes(this.channelIdValue)) {
            this.hidechatCheck = true;
        }
    }
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    ngOnInit() {
        this.processErrorCode();
        this.getBehaviorData();
    }

    processErrorCode() {
        let pageName;
        this.paymentMethod = this.response?.paymentMethod;
        const errorCode = this.response?.errorResponse?.errorCode || '';
        if (this.response && this.response?.status !== ResponseStatus.SUCCESS) {
            if (this.response?.errorResponse) {
                if (errorCode == ErrorCode.ServiceUnavailable) {
                    this.kycDetails = this.response.kycCheckResponse;
                    if (this.kycDetails) {
                        this.jurisdiction = this.response?.kycCheckResponse?.jurisdiction;

                        if (['bs', 'ps'].includes(this.dataService?.sessionInfo?.userId.substring(0, 2))) {
                            this.IsSwedenFE = true;
                        }
                        if (this.greeceFEUsers.includes(this.dataService?.sessionInfo?.userId.substring(0, 2))) {
                            this.IsGreeceFE = true;
                        }
                        if (this.kycDetails?.kycLimit?.value) {
                            this.kycDetails.kycLimit.value = parseFloat(this.kycDetails?.kycLimit?.value).toFixed(2);
                        }

                        if (this.kycDetails?.kycRemainingLimit?.value) {
                            this.kycDetails.kycRemainingLimit.value = parseFloat(this.kycDetails?.kycRemainingLimit?.value).toFixed(2);
                        }
                        if (Jurisdiction.DEU === this.kycDetails?.jurisdiction) {
                            this.isDEUJurisdiction = true;
                            this.isSportsPreference = this.kycDetails?.productPreference === ProductType.SPORTSBOOK;
                            this.isDepositAllowedOnOtherProduct = this.kycDetails?.depositAllowedOnOtherProduct;
                            if (this.kycDetails?.gamingLimitInfo) {
                                this.productToShow = this.getProductToShow(this.kycDetails?.gamingLimitInfo);
                                if (this.isSportsPreference) {
                                    if (this.kycDetails?.gamingLimitInfo?.brandSupportBothCasinoAndPokerProduct === Config.YES) {
                                        this.proposedProduct = ProposedProduct.SLOTSANDPOKER;
                                    } else if (this.kycDetails?.gamingLimitInfo?.brandSupportOnlyCasinoProduct === Config.YES) {
                                        this.proposedProduct = ProposedProduct.SLOTS;
                                    } else {
                                        this.proposedProduct = ProposedProduct.POKER;
                                    }
                                } else {
                                    this.proposedProduct = ProposedProduct.SPORTS;
                                }
                            }
                            if (['KYC_LIMIT_EXCEEDED', 'KYC_GRACEPERIOD_COMPLETED'].includes(this.response?.errorResponse?.errorMessage)) {
                                this.isShowSofortCTA = true;
                            }
                        }
                    }
                    pageName = PageName.KYCLimitsExceeded;
                } else if (this.paymentMethod == 'INTERCHECKS_ACH' && errorCode?.startsWith('ERR_')) {
                    this.showAchIntercheksMessage = true;
                    this.errorDescription = this.getErrorMessage(errorCode);
                    const isErrorMsgAvailable = ['INVALID', 'MISSING', 'UNAVAILABLE', 'DECLINE'].find((str) => errorCode.includes(str));
                    if (!this.errorDescription && isErrorMsgAvailable) {
                        this.errorDescription = this.getErrorMessage('ERR_INVALID_ACCOUNT_ID');
                    } else if (!this.errorDescription) {
                        this.errorDescription = this.getErrorMessage();
                    }
                } else if (errorCode === ErrorCode.gamingLimitsNotConfigured) {
                    pageName = PageName.GamingLimitsNotConfigured;
                    this.gamingLimitsNotConfigured = true;
                    this.productSelectedError = this.response?.errorResponse?.productPreference;
                    this.isCasinoProductError = this.response?.errorResponse?.gamingLimitInfo?.brandSupportOnlyCasinoProduct === Config.YES;
                    this.isPokerProductError = this.response?.errorResponse?.gamingLimitInfo?.brandSupportOnlyPokerProduct === Config.YES;
                    this.isCasinoAndPokerProductError =
                        this.response?.errorResponse?.gamingLimitInfo?.brandSupportBothCasinoAndPokerProduct === Config.YES;
                    this.depositLimitsUrlError = '';
                    if (this.userdataService?.userData?.configParams?.depositLimitsUrl) {
                        this.depositLimitsUrlError = this.userdataService?.userData?.configParams?.depositLimitsUrl;
                    }
                } else if (ErrorCode.prorgDepLimitErrorCode.indexOf(errorCode) != -1 || errorCode == '189') {
                    pageName = PageName.ProrgDepLimitExceeded;
                    this.prorgDepLimitErrorDetails = this.response?.errorResponse;
                    if (['152', '189'].includes(errorCode)) {
                        this.positionEvnt = this.response?.errorResponse?.errorMessage.includes('TO_BE_EXCEEDED')
                            ? 'user exceeded aff annual loss limit'
                            : 'user exhausted aff annual loss limit';
                        this.labelEvnt = 'aff annual loss limit';
                        this.limitType = 'hardstop ltm';
                        this.gtmService.raiseEventForAffordabilityMsgBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            this.positionEvnt,
                            this.response?.errorResponse?.playerLevel,
                            this.response?.errorResponse?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                        );
                    }
                    if (errorCode == '155') {
                        this.positionEvnt = this.response.errorResponse.errorMessage.includes('TO_BE_EXCEEDED')
                            ? 'user exceeded f30 hardstop' + Number(this.response.errorResponse?.limit) / 1000 + 'k limit'
                            : 'user exhausted f30 hardstop' + Number(this.response.errorResponse?.limit) / 1000 + 'k limit';
                        this.gtmService.raiseEventForProrg30daysLoad(this.positionEvnt);
                    }
                    if (
                        (this.pullchatEnabled || this.zendeskEnabled) &&
                        ['deposit_12months_limit_exceeded', 'deposit_30days_limit_exceeded'].includes(
                            this.prorgDepLimitErrorDetails.errorMessage.toLowerCase(),
                        )
                    ) {
                        this.showChatCTA = true;
                    }
                } else if (ErrorCode.amlNetDepLimitErrorCodes.indexOf(errorCode) != -1) {
                    pageName = PageName.AMLNetDepositLimitsExceeded;
                    this.amlNetDepLimitErrorDetails = this.response?.errorResponse;
                    if (errorCode === ErrorCode.AMLNetDepositLimitsExceeded_150 && this.response?.errorResponse?.playerLevelOne) {
                        this.response.errorResponse.errorMessage =
                            'affordability limit exceeded - ' +
                            this.response?.errorResponse?.netDepLimit +
                            this.response?.errorResponse?.accountCurrency;
                    }
                    if ((this.pullchatEnabled || this.zendeskEnabled) && errorCode === ErrorCode.AMLNetDepositLimitsExceeded_151) {
                        this.showChatCTA = true;
                    }
                } else if (ErrorCode.affordibilityGrossLimitErrorCodes.indexOf(errorCode) != -1) {
                    this.isPlayerLevelOne = this.response?.errorResponse?.playerLevelOne;
                    if (errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_177) {
                        this.affordibilityMonthlyGrossDepLimitErrorDetails = this.response?.errorResponse;
                        this.limitType = 'aff monthly gross';
                        this.labelEvnt = 'request higher limit';
                        this.positionEvnt = 'gdl aff montly limit';
                        this.gtmService.raiseEventForAffordabilityBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            'not applicable',
                            this.affordibilityMonthlyGrossDepLimitErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.affordibilityMonthlyGrossDepLimitErrorDetails?.additionalData?.AffEmploymentGroup,
                            this.affordibilityMonthlyGrossDepLimitErrorDetails?.playerLevel,
                        );
                    } else if (errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_178) {
                        this.affordibilityYearlyGrossDepLimitErrorDetails = this.response?.errorResponse;
                        this.limitType = 'aff yearly gross';
                        this.labelEvnt = 'request higher limit';
                        this.positionEvnt = 'gdl aff yearly limit';
                        this.gtmService.raiseEventForAffordabilityBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            'not applicable',
                            this.affordibilityYearlyGrossDepLimitErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.affordibilityYearlyGrossDepLimitErrorDetails?.additionalData?.AffEmploymentGroup,
                            this.affordibilityYearlyGrossDepLimitErrorDetails?.playerLevel,
                        );
                    } else if (errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_179) {
                        this.affordibilityMilestoneSgqGrossLimitErrorDetails = this.response?.errorResponse;
                        this.limitType = 'affordability questionnaire';
                        this.labelEvnt = 'affordability questionnaire';
                        this.positionEvnt = 'user at ' + Number(this.response?.errorResponse?.limit) / 1000 + 'k gdl mile stone';
                        this.gtmService.raiseEventForAffordabilityBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            'not applicable',
                            this.affordibilityMilestoneSgqGrossLimitErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.affordibilityMilestoneSgqGrossLimitErrorDetails?.additionalData?.AffEmploymentGroup,
                            this.affordibilityMilestoneSgqGrossLimitErrorDetails?.playerLevel,
                        );
                    } else if (errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_180) {
                        this.affordibilityMilestoneSelfCertGrossLimitErrorDetails = this.response?.errorResponse;
                        this.limitType = '';
                        this.labelEvnt = 'self certification';
                        this.positionEvnt = 'user at ' + Number(this.response?.errorResponse?.limit) / 1000 + 'k gdl mile stone';
                        this.gtmService.raiseEventForAffordabilityBannerLoad(
                            'self certification',
                            'user at ' + Number(this.response?.errorResponse?.limit) / 1000 + 'k gdl mile stone',
                            'not applicable',
                            this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.additionalData?.AffEmploymentGroup,
                            this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.playerLevel,
                        );
                    } else if ([ErrorCode.GroupBasedAffGrossDepositLimitsExceeded_183, '193', '194'].includes(errorCode)) {
                        this.affordibilityYearlyGrossDepLimitErrorDetails = this.response?.errorResponse;
                        if (['193', '194'].includes(errorCode)) {
                            this.positionEvnt = this.affordibilityYearlyGrossDepLimitErrorDetails?.errorMessage?.includes('TO_BE_EXCEEDED')
                                ? 'user exceeded rolling 30 day limit banner'
                                : 'user exhausted rolling 30 day limit banner';
                            this.limitType = 'aff rolling  30d gross limit';
                            this.labelEvnt = 'aff annual gross';
                        } else {
                            this.positionEvnt = this.affordibilityYearlyGrossDepLimitErrorDetails?.errorMessage?.includes('TO_BE_EXCEEDED')
                                ? 'user exceeded gdl yearly limit'
                                : 'user exhausted gdl yearly limit';
                            this.labelEvnt = 'request higher limit';
                            this.limitType = 'group based annual gross';
                        }
                    } else if (['181', '190'].includes(errorCode)) {
                        this.affordibilityLtmGrossLimitErrorDetails = this.response?.errorResponse;
                        this.positionEvnt = this.response.errorResponse.errorMessage.includes('TO_BE_EXCEEDED')
                            ? 'user exceeded aff ltm gross limit'
                            : 'user exhausted aff ltm gross limit';
                        this.labelEvnt = 'ltm gross';
                        this.limitType = 'hardstop ltm gross';
                        this.gtmService.raiseEventForAffordabilityBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            this.positionEvnt,
                            this.affordibilityLtmGrossLimitErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.affordibilityLtmGrossLimitErrorDetails?.additionalData?.AffEmploymentGroup,
                            this.affordibilityLtmGrossLimitErrorDetails?.playerLevel,
                        );
                    }
                } else if (ErrorCode.affordibilityDepLimitErrorCodes.indexOf(errorCode) != -1) {
                    pageName = PageName.AffordibilityNetDepositLimitsExceeded;
                    if (errorCode === ErrorCode.AffordibilityNetDepositLimitsExceeded_156) {
                        this.affordibilityMonthlyNetDepLimitErrorDetails = this.response?.errorResponse;
                        if (this.response?.errorResponse?.templateName === ErrorTemplate.aml_limit_exceeded) {
                            this.response.errorResponse.errorMessage = 'already exceeded loss limit - monthly';
                        } else {
                            this.response.errorResponse.errorMessage = 'almost exceeded loss limit - monthly';
                        }
                    } else if (errorCode == ErrorCode.AffordibilityNetDepositLimitsExceeded_157) {
                        this.affordibilityYearlyNetDepLimitErrorDetails = this.response?.errorResponse;
                        if (this.response?.errorResponse?.templateName === ErrorTemplate.aml_limit_exceeded) {
                            this.response.errorResponse.errorMessage = 'already exceeded loss limit - annually';
                        } else {
                            this.response.errorResponse.errorMessage = 'almost exceeded loss limit - annually';
                        }
                    } else if (errorCode == ErrorCode.AffordibilityNetDepositLimitsExceeded_175) {
                        this.affordibility3kMilestoneLimitErrorDetails = this.response?.errorResponse;
                        this.labelEvnt = 'affordability questionnaire';
                        this.positionEvnt = Number(this.response?.errorResponse?.limit) / 1000 + 'k mile stone';
                        this.limitType = '';
                        this.gtmService.raiseEventForAffordabilityBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            'banner',
                            this.affordibility3kMilestoneLimitErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.affordibility3kMilestoneLimitErrorDetails?.additionalData?.AffEmploymentGroup,
                            this.affordibility3kMilestoneLimitErrorDetails?.playerLevel,
                        );
                    } else if (errorCode == ErrorCode.AffordibilityNetDepositLimitsExceeded_172) {
                        this.affordibilityTUDepLimitErrorDetails = this.response?.errorResponse;
                        if (this.affordibilityTUDepLimitErrorDetails.errorMessage == 'TU_DEPOSIT_LIMIT_EXCEEDED') {
                            this.gtmService.raiseEventForAffordabilityPaymentError('tu deposit limits exceeded');
                        } else {
                            this.gtmService.raiseEventForAffordabilityPaymentError('tu deposit limits to be exceeded');
                        }
                    } else if (errorCode == ErrorCode.AffordibilityNetDepositLimitsExceeded_176) {
                        this.affordibility8kMilestoneLimitErrorDetails = this.response?.errorResponse;
                        this.limitType = '';
                        this.labelEvnt = 'self certification';
                        this.positionEvnt = Number(this.response?.errorResponse?.limit) / 1000 + 'k mile stone';
                        this.gtmService.raiseEventForAffordabilityBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            'banner',
                            this.affordibility8kMilestoneLimitErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.affordibility8kMilestoneLimitErrorDetails?.additionalData?.AffEmploymentGroup,
                            this.affordibility8kMilestoneLimitErrorDetails?.playerLevel,
                        );
                    } else {
                        this.affordibilityHardStopLimitErrorDetails = this.response?.errorResponse;
                        if (errorCode == '173') {
                            this.limitType = 'f30d limit';
                            this.labelEvnt = 'request higher limit';
                            this.positionEvnt = Number(this.response?.errorResponse?.limit) / 1000 + 'k hardstop';
                        } else if (errorCode == '174') {
                            this.limitType = 'hardstop ltm';
                            this.labelEvnt = 'request higher limit';
                            this.positionEvnt = Number(this.response?.errorResponse?.limit) / 1000 + 'k hardstop';
                        }
                        this.gtmService.raiseEventForAffordabilityBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            'banner',
                            this.affordibilityHardStopLimitErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.affordibilityHardStopLimitErrorDetails?.additionalData?.AffEmploymentGroup,
                            this.affordibilityHardStopLimitErrorDetails?.playerLevel,
                        );
                    }
                } else if (ErrorCode.svocAffordibilityErrorCodes.indexOf(errorCode) != -1) {
                    pageName = PageName.SvocAffordibilityNetDepositLimitsExceeded;
                    this.svocAffordabilityErrorDetails = this.response?.errorResponse;
                    if (
                        (this.pullchatEnabled || this.zendeskEnabled) &&
                        [ErrorCode.SvocAffordibilityNetDepositLimitsExceeded_161, ErrorCode.SvocAffordibilityNetDepositLimitsExceeded_160].includes(
                            this.svocAffordabilityErrorDetails?.errorCode,
                        ) &&
                        this.svocAffordabilityErrorDetails?.errorMessage?.toUpperCase() === 'AML_LIMIT_EXCEEDED'
                    ) {
                        this.showChatCTA = true;
                    }
                    this.isPlayerLevelOne = this.response?.errorResponse?.playerLevelOne;
                    if (['166', '167'].includes(this.svocAffordabilityErrorDetails?.errorCode)) {
                        this.labelEvnt = this.svocAffordabilityErrorDetails?.errorCode == '166' ? 'aff monthly loss limit' : 'aff annual loss limit';
                        this.limitType = this.svocAffordabilityErrorDetails?.errorCode == '166' ? 'aff monthly limit' : 'aff annual limit';
                        this.positionEvnt =
                            this.svocAffordabilityErrorDetails?.errorMessage == 'AFFORDABILITY_LIMIT_TO_BE_EXCEEDED'
                                ? 'deposit crossing threshold banner'
                                : 'user exhausted loss limit banner';
                        this.gtmService.raiseEventForAffordabilityMsgBannerLoad(
                            this.labelEvnt,
                            this.positionEvnt,
                            'not applicable',
                            this.svocAffordabilityErrorDetails?.playerLevel,
                            this.svocAffordabilityErrorDetails?.additionalData?.AffAgeGroup,
                            this.limitType,
                            this.svocAffordabilityErrorDetails?.additionalData?.AffEmploymentGroup,
                        );
                    } else if (['182'].includes(this.svocAffordabilityErrorDetails?.errorCode)) {
                        this.positionEvnt = this.svocAffordabilityErrorDetails?.errorMessage?.includes('TO_BE_EXCEEDED')
                            ? 'user exceeded monthly loss limit banner'
                            : 'user exhausted monthly loss limit banner';
                        this.labelEvnt = 'request higher limit';
                        this.limitType = 'group based monthly limit';
                    }
                } else if (['195', '196', '197'].includes(errorCode)) {
                    this.frarolling90dayLossLimitDetails = this.response?.errorResponse;
                    this.affFraRollingPeriod = this.frarolling90dayLossLimitDetails?.additionalData?.affFraRollingPeriod || '90';
                    this.positionEvnt = this.frarolling90dayLossLimitDetails?.errorMessage?.toUpperCase().includes('TO_BE_EXCEEDED')
                        ? `user exceeded rolling ${this.affFraRollingPeriod} day limit banner`
                        : `user exhausted rolling ${this.affFraRollingPeriod} day limit banner`;
                    this.limitType = `aff rolling ${this.affFraRollingPeriod}d limit`;
                    this.labelEvnt = 'self certification';
                    this.gtmService.raiseEventForAffFRAMsgBannerLoadClick(
                        this.labelEvnt,
                        'load',
                        this.positionEvnt,
                        this.positionEvnt,
                        'not applicable',
                        this.response?.errorResponse?.playerLevel,
                        this.response?.errorResponse?.additionalData?.AffAgeGroup,
                        this.limitType,
                        this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                    );
                } else if (['185', '186'].includes(errorCode)) {
                    this.affordabilityQuestionaireLimit = this.response?.errorResponse;
                    this.positionEvnt = 'user reached ' + Number(this.affordabilityQuestionaireLimit?.limit) / 1000 + 'k in 12months net loss banner';
                    this.labelEvnt = 'affordability questionnaire';
                    this.limitType = 'aff questionnnarie ltm';
                } else if (['191', '192'].includes(errorCode)) {
                    this.rolling30dayLossLimitDetails = this.response?.errorResponse;
                    this.positionEvnt = this.rolling30dayLossLimitDetails?.errorMessage?.includes('TO_BE_EXCEEDED')
                        ? 'user exceeded rolling 30 day limit banner'
                        : 'user exhausted rolling 30 day limit banner';
                    this.limitType = 'aff rolling 30d limit';
                    this.labelEvnt = 'aff monthly loss limit';
                } else if (errorCode === ErrorCode.AffordabilityMaxLossLimitsuggestion) {
                    this.showMaxLossLimitMsg = true;
                    this.affMaxLossLimitSuggestionErrorDetails = this.response?.errorResponse;
                    this.labelEvnt = 'svoc max loss limit';
                    this.positionEvnt = 'max loss limit suggestion';
                    this.limitType = 'max loss limit interceptor';
                } else if (ErrorCode.purchaseLimitsErrorCodes.indexOf(errorCode) != -1) {
                    pageName = PageName.PurchaseLimitsExceeded;
                    this.behaviorData.changePurchaseLimitsErrorDetails(this.response?.errorResponse);
                } else if (
                    ErrorCode.centralDepLimitErrorCodes.indexOf(errorCode) != -1 &&
                    this.response?.errorResponse?.errorMessage === 'DEPOSIT_EXCEEDS_BUDGET'
                ) {
                    this.CentralDepLimitsErrorDetails = this.response;
                    if (parseFloat(this.response?.errorResponse?.remainingAmount) > parseFloat('0')) {
                        this.ExceededCase = true;
                    } else {
                        this.ExceededCase = false;
                    }
                    this.gtmService.raiseEventForCDRLimitExceeded(this.ExceededCase, this.response.paymentMethod, this.response.totalDepositCount);
                } else if (ErrorCode.rgLimitsErrorCodes.indexOf(errorCode) != -1) {
                    pageName = PageName.DepositLimitsExceeded;
                    this.behaviorData.changeRgLimitsErrorDetails(this.response?.errorResponse);
                } else if (errorCode === ErrorCode.belgiumAffLimitErrorCode) {
                    pageName = PageName.DepositLimitsExceeded;
                    this.belgiumAffLimitsErrorDetails = this.response?.errorResponse;
                    this.isBelgiumLimitAvailable = this.response?.errorResponse?.revisedAmount > 0;
                    this.availableBelgiumLimit = this.response?.errorResponse?.revisedAmount;
                    this.maxPurchaseLimit = this.response?.errorResponse?.maxPurchaseLimit;
                    this.nextDate = this.response?.errorResponse?.nextDateToShow;
                } else if (errorCode === ErrorCode.sportsLimitsErrorCode) {
                    pageName = PageName.DepositLimitsExceeded;
                    this.sportsLimitIncreaseUrl = this.response?.errorResponse?.sportsLimitIncreaseUrl;
                    this.sportsLimitsErrorDetails = this.response?.errorResponse;
                    this.behaviorData.changeSportsLimitsErrorDetails(this.sportsLimitsErrorDetails);
                    this.paymentMethod = this.response.paymentMethod;
                    this.isGamesProductSupported = this.response?.errorResponse?.productPreference === ProductType.CASINO;
                } else if (errorCode === ErrorCode.gamingLimitsErrorCode) {
                    pageName = PageName.DepositLimitsExceeded;
                    this.gamingLimitsErrorDetails = this.response?.errorResponse;
                    this.behaviorData.changeGamingLimitsErrorDetails(this.gamingLimitsErrorDetails);
                    this.depositLimitsUrlError = this.response?.errorResponse?.depositLimitsUrl;
                    this.isCasinoProductError = this.response?.errorResponse?.gamingLimitInfo.brandSupportOnlyCasinoProduct === Config.YES;
                    this.isPokerProductError = this.response?.errorResponse?.gamingLimitInfo.brandSupportOnlyPokerProduct === Config.YES;
                    this.isCasinoAndPokerProductError =
                        this.response?.errorResponse?.gamingLimitInfo.brandSupportBothCasinoAndPokerProduct === Config.YES;
                    this.isSportsProductSupported = this.response?.errorResponse?.productPreference === ProductType.SPORTSBOOK;
                } else if (errorCode === ErrorCode.instrumentDepositLimitExceeded) {
                    pageName = PageName.InstrumentLimitExceeded;
                    this.behaviorData.changeInstrumentDepositLimitErrorDetails(this.response?.errorResponse);
                } else if (errorCode == ErrorCode.intensivePlayerCode) {
                    pageName = PageName.IntensivePlayerMessage;
                    this.intensivePlayerMessage = this.response?.errorResponse;
                    this.gtmService.intensivePlayerMsgLoad(this.paymentMethod);
                } else if (errorCode == ErrorCode.riskyPlayerCode) {
                    pageName = PageName.RiskPlayerMessage;
                    this.riskPlayerMessage = this.response?.errorResponse;
                    this.gtmService.riskyPlayerUnsuccessfulDep();
                } else if (ErrorCode.gamerscardErrorCodes.indexOf(errorCode) != -1) {
                    pageName = PageName.GamerscardErrorCodes;
                    this.gamerscardErrorCodeDetails = this.response?.errorResponse;
                } else if (errorCode === ErrorCode.creditCardBlocked) {
                    pageName = PageName.CreditCardBlockDetails;
                    this.creditCardBlockDetails = this.response?.errorResponse;
                    const ccData = { component: this.tempObj };
                    ccData.component.CategoryEvent = 'credit card opt out | opt in';
                    ccData.component.PositionEvent = 'cashier page';
                    ccData.component.LocationEvent = 'cashier page';
                    ccData.component.EventDetails = 'user with creditcard optout choose credit card as payment option';
                    if (this.response?.errorResponse?.errorMessage == 'CC_DEPOSIT_BLOCK') {
                        ccData.component.LabelEvent = 'credit card opt out - warning message';
                        ccData.component.ActionEvent = 'warning message displayed';
                        this.gtmService.raiseComponentEvent('Event.Tracking', ccData);
                    } else if (this.response?.errorResponse?.errorMessage == 'CC_DEPOSIT_BLOCK_COOLOFF') {
                        ccData.component.LabelEvent = 'credit card deposits disabled for 24-hour - warning message';
                        ccData.component.ActionEvent = 'warning message displayed';
                        this.gtmService.raiseComponentEvent('Event.Tracking', ccData);
                    }
                } else if (errorCode === ErrorCode.arcErrorCode) {
                    pageName = PageName.ArcDepositDecline;
                    this.arcDepositDecline = '';
                    this.showArcGTMEvnt = true;
                    if (this.response?.errorResponse?.errorMessage == 'arc_deposit_decline_intervention_message') {
                        this.arcDepositBlockStatus = this.response.userARCDeclinedDepositStatus;
                        const ccData = { payment: this.tempObj };
                        ccData.payment.error = 'maximum allowed decline deposits reached - deposit ability blocked for 24h';
                        this.gtmService.raiseComponentEvent('paymentError', ccData);
                    } else if (this.response?.errorResponse?.errorMessage == 'arc_deposit_decline_interaction_message') {
                        this.arcDepositDecline = this.response?.errorResponse;
                        this.gtmService.raiseEventForArcUnusualDeposit('unusualArcDepositInteractionMessage', 'quick deposit');
                    }
                } else if (ErrorCode.cdrMessagesErrorCodes.includes(errorCode)) {
                    this.cdrMessagesErrorDetails = this.response?.errorResponse;
                    this.paymentMethod = this.response.paymentMethod;
                } else if (ErrorCode.doNotHonorMessageCode.includes(errorCode)) {
                    pageName = PageName.DoNotHonorMessage;
                    this.doNotHonorErrorDetails = this.response?.errorResponse;
                } else if (ErrorCode.insufficientFundsErrorMessageCode.includes(errorCode)) {
                    pageName = PageName.InsufficientFunds;
                    this.insufficientFundsErrorDetails = this.response?.errorResponse;
                } else if (ErrorCode.invalidCvvCode.includes(errorCode)) {
                    this.invalidCvvErrorDetails = this.response?.errorResponse;
                } else if (errorCode == null) {
                    this.internalErrorDetails = this.response?.errorResponse;
                } else if (['2400', '2401', '2402'].includes(errorCode) && this.response.paymentMethod == 'FLASH1VOUCHER') {
                    pageName = PageName.Flash1VoucherError;
                } else if (errorCode === ErrorCode.MaxLossLimitMonthlyExceeded_184) {
                    const isExceeded = this.response?.errorResponse?.errorMessage == 'MAX_LOSS_LIMIT_MONTHLY_EXCEEDED' ? true : false;
                    this.maxLossLimitMonthlyExceededErrorDetails = this.response?.errorResponse;
                    this.gtmService.raiseEventForMaxLossLimitBannerLoad(
                        isExceeded,
                        this.response?.errorResponse?.additionalData?.AffAgeGroup,
                        'max loss limit ltm',
                        this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                        this.response?.errorResponse?.playerLevel,
                    );
                } else if (ErrorCode.SvocPurchaseLimits.includes(errorCode)) {
                    this.svocPurchaseLimitsErrorDetails = this.response?.errorResponse;
                    this.paymentMethod = this.response.paymentMethod;
                    this.setFrequency(errorCode);
                } else if (ErrorCode.SvocTxnLimits.includes(errorCode)) {
                    this.svoctxnLimitErrorDetails = this.response?.errorResponse;
                    this.paymentMethod = this.response.paymentMethod;
                    this.setFrequency(errorCode);
                } else if (ErrorCode.ParRiskChecksFailure.includes(errorCode) || ErrorCode.ParRiskChecksRgClosedFailure.includes(errorCode)) {
                    pageName = 'ParRiskChecksFailure';
                    this.ParRiskFailureErrorDetails = this.response?.errorResponse;
                    if (errorCode.split('/').length > 1) {
                        this.errorDescription = this.translate.instant(
                            'PARTY.CASHIER.web.deposit.par.riskCheck.failure.' + errorCode.split('/')[1] + '.description',
                            { url: this.customerContactURL },
                        );
                    } else {
                        this.errorDescription = this.translate.instant(
                            'PARTY.CASHIER.web.deposit.par.riskCheck.failure.' + errorCode + '.description',
                            { url: this.customerContactURL },
                        );
                    }
                } else if (
                    ![ErrorCode.adaMessageCode || ErrorCode.playBreakCode || ErrorCode.sessionTimeoutErrorCode || errorCode == '2046'].includes(
                        errorCode,
                    ) &&
                    !this.depositService?.paypalDirectBadFunding
                ) {
                    pageName = PageName.DepositDecline;
                    this.errorDetails = this.response?.errorResponse;
                }
            } else if (this.response.status && this.response.status == ErrorCode.ValidationError_400) {
                this.validationError = this.response.status;
            } else {
                if (this.response.status === ResponseStatus.FAILURE) {
                    pageName = PageName.DepositDecline;
                } else {
                    this.defaultError = true;
                }
                this.error = this.response.status;
            }
            if (['182', '183', '185', '186', '187', '189', '191', '192', '193', '194'].includes(errorCode)) {
                this.gtmService.raiseEventForAffordabilityMsgBannerLoad(
                    this.labelEvnt,
                    this.positionEvnt,
                    this.positionEvnt,
                    this.response?.errorResponse?.playerLevel,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                );
            }

            if (pageName) {
                this.gtmService.raiseEvent('paymentError', pageName, this.response.paymentMethod);
            }
            this.resizeService.resizeCashier();
        }
    }

    getProductToShow(gamingLimitInfo: any) {
        if (this.isSportsPreference) {
            return ProposedProduct.SPORTS;
        } else if (gamingLimitInfo?.brandSupportBothCasinoAndPokerProduct === Config.YES) {
            return ProposedProduct.SLOTSANDPOKER;
        } else if (gamingLimitInfo?.brandSupportOnlyCasinoProduct === Config.YES) {
            return ProposedProduct.SLOTS;
        } else {
            return ProposedProduct.POKER;
        }
    }

    postActionMessage(action: any) {
        this.quickDepositMessageService.sendOutput('action=' + action);
    }
    maxLossLimitCTA(status: any) {
        this.depositService.affMaxLossLimitInterceptorCall(status);
        let buttonName;
        let urlClicked;
        if (status == 'REJECT') {
            this.showMaxLossLimitMsg = false;
            urlClicked = window.location.href;
            buttonName = 'Not Now cta';
        } else {
            buttonName = 'Set Max Loss Limit cta';
            urlClicked = this.affMaxLossLimitSuggestionErrorDetails?.sgqLink;
        }
        this.gtmService.raiseEventForAffordabilityButtons(
            this.labelEvnt,
            buttonName,
            this.positionEvnt,
            urlClicked,
            this.affMaxLossLimitSuggestionErrorDetails?.playerLevel,
            this.affMaxLossLimitSuggestionErrorDetails?.additionalData?.AffAgeGroup,
            this.limitType,
            this.affMaxLossLimitSuggestionErrorDetails?.additionalData?.AffEmploymentGroup,
        );
    }

    postAppMessage(url: any) {
        const clientScheme = this.cookieService.get('clientScheme');
        if (clientScheme) {
            const appUrl = clientScheme + '://?event=navigateToUrl&url=' + encodeURIComponent(url);
            document.location.href = appUrl;
        } else {
            document.location.href = url;
        }
    }

    closeQD() {
        if (this.showArcGTMEvnt) {
            this.gtmService.raiseCloseEvent();
        }
        this.eventService.raiseCloseEvent();
    }

    submitArcDeposit() {
        this.depositService.showDepositFailure.set(false);
        this.resizeService.resizeCashier();
        this.depositService.depositInfo.arcHighVolumeCompleteDeposit = 'true';
        this.depositService.submitDeposit();
    }

    handleLiveChatResponse(response?: any) {
        if (response && ['1001', '1000'].includes(response.toString())) {
            this.showChatNotAvailable = true;
        }
    }

    triggerChat(linkName: any) {
        this.chatService.triggerChat(this.handleLiveChatResponse);
        if (this.response.errorResponse.errorCode == '155') {
            this.gtmService.raiseEventForProrg30daysClick(this.positionEvnt, window.location.href, 'chat here');
        }
        if (['152', '189', '181', '190', '176', '180', '182'].includes(this.response?.errorResponse?.errorCode)) {
            this.gtmService.raiseEventForAffordabilityButtons(
                this.labelEvnt,
                linkName,
                this.positionEvnt,
                window.location.href,
                this.response?.errorResponse?.playerLevel,
                this.response?.errorResponse?.additionalData?.AffAgeGroup,
                this.limitType,
                this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
            );
        }
    }

    monthlyLimit(event: any, linkName: string) {
        if (event?.target?.tagName?.toLowerCase() == 'a') {
            if (
                [
                    ErrorCode.AffordibilityGrossDepositLimitsExceeded_177,
                    ErrorCode.AffordibilityGrossDepositLimitsExceeded_178,
                    ErrorCode.GroupBasedAffGrossDepositLimitsExceeded_183,
                    '193',
                    '194',
                    '166',
                    '167',
                    '182',
                ].includes(this.response?.errorResponse?.errorCode)
            ) {
                this.gtmService.raiseEventForAffordabilityButtons(
                    this.labelEvnt,
                    linkName,
                    this.positionEvnt,
                    this.response?.errorResponse?.lossLimitFaqLink,
                    this.response?.errorResponse?.playerLevel,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                );
            } else if (this.response?.errorResponse?.errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_181) {
                if (
                    ['DEPOSIT_12MONTHS_LIMIT_GROSS_EXCEEDED_BEA', 'DEPOSIT_12MONTHS_LIMIT_GROSS_TO_BE_EXCEEDED_BEA'].includes(
                        this.affordibilityLtmGrossLimitErrorDetails?.errorMessage?.toUpperCase(),
                    )
                ) {
                    this.gtmService.raiseEventForAffordabilityButtons(
                        'ltm gross',
                        'deposit cap under 25 link',
                        'user at ' + Number(this.response?.errorResponse?.limit) / 1000 + 'k gdl hard stop ltm under 25',
                        this.affordibilityLtmGrossLimitErrorDetails?.hardstopInfoLink,
                        this.response?.errorResponse?.playerLevel,
                        this.response?.errorResponse?.additionalData?.AffAgeGroup,
                        this.limitType,
                        this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                    );
                } else {
                    this.gtmService.raiseEventForAffordabilityButtons(
                        'ltm gross',
                        'deposit cap link',
                        'user at ' + Number(this.response?.errorResponse?.limit) / 1000 + 'k gdl hard stop ltm',
                        this.affordibilityLtmGrossLimitErrorDetails?.hardstopInfoLink,
                        this.response?.errorResponse?.playerLevel,
                        this.response?.errorResponse?.additionalData?.AffAgeGroup,
                        this.limitType,
                        this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                    );
                }
            } else {
                this.gtmService.raiseEventForAffordabilityButtons(
                    this.labelEvnt,
                    linkName,
                    this.positionEvnt,
                    this.response?.errorResponse?.hardstopInfoLink,
                    this.response?.errorResponse?.playerLevel,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                );
            }
        }
    }

    contactUsLink(event: any, linkName: any) {
        if (event?.target?.tagName.toLowerCase() == 'a') {
            if (this.response?.errorResponse?.errorCode == ErrorCode.AffordabilityBannerlinks_176) {
                this.gtmService.raiseEventForAffordabilityButtons(
                    'self certification',
                    'contact us link',
                    Number(this.affordibility8kMilestoneLimitErrorDetails?.limit) / 1000 + 'k limit',
                    this.affordibility8kMilestoneLimitErrorDetails?.contactUs,
                    this.response?.errorResponse?.playerLevel,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                );
            } else if (['195', '196', '197'].includes(this.response?.errorResponse?.errorCode)) {
                this.gtmService.raiseEventForAffFRAMsgBannerLoadClick(
                    this.labelEvnt,
                    'click',
                    this.positionEvnt,
                    'chat with us link',
                    this.response?.errorResponse?.contactUs,
                    this.response?.errorResponse?.playerLevel,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                );
            } else if (this.response?.errorResponse?.errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_180) {
                this.gtmService.raiseEventForAffordabilityButtons(
                    'self certification',
                    'contact us link',
                    'user at ' + Number(this.response?.errorResponse?.limit) / 1000 + 'k gdl mile stone',
                    this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.contactUs,
                    this.response?.errorResponse?.playerLevel,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                );
            } else if (
                [ErrorCode.AffordibilityGrossDepositLimitsExceeded_181, '190', '152', '189'].includes(this.response?.errorResponse?.errorCode)
            ) {
                this.gtmService.raiseEventForAffordabilityButtons(
                    this.labelEvnt,
                    linkName,
                    this.positionEvnt,
                    this.response?.errorResponse?.contactUs,
                    this.response?.errorResponse?.playerLevel,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                );
            } else {
                this.gtmService.raiseEventForAffordabilityButtons(
                    'request higher limit',
                    'contact us link',
                    Number(this.response?.errorResponse?.limit) / 1000 + 'k hardStop',
                    this.response?.errorResponse?.contactUs,
                    this.response?.errorResponse?.playerLevel,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                );
            }
        }
    }

    increaseLimits() {
        if (this.response?.errorResponse?.errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_177) {
            this.gtmService.raiseEventForAffordabilityButtons(
                'request higher limit',
                'increase limit cta',
                'gdl aff montly limit',
                this.affordibilityMonthlyGrossDepLimitErrorDetails?.increaseLimitsUrl,
                this.affordibilityMonthlyGrossDepLimitErrorDetails?.playerLevel,
                this.affordibilityMonthlyGrossDepLimitErrorDetails.additionalData?.AffAgeGroup,
                this.limitType,
                this.affordibilityMonthlyGrossDepLimitErrorDetails.additionalData?.AffEmploymentGroup,
            );
        } else if ([ErrorCode.AffordibilityGrossDepositLimitsExceeded_178, '183', '193', '194'].includes(this.response?.errorResponse?.errorCode)) {
            this.gtmService.raiseEventForAffordabilityButtons(
                'request higher limit',
                'increase limit cta',
                'gdl aff yearly limit',
                this.affordibilityYearlyGrossDepLimitErrorDetails?.increaseLimitsUrl,
                this.affordibilityYearlyGrossDepLimitErrorDetails?.playerLevel,
                this.affordibilityYearlyGrossDepLimitErrorDetails.additionalData?.AffAgeGroup,
                this.limitType,
                this.affordibilityYearlyGrossDepLimitErrorDetails.additionalData?.AffEmploymentGroup,
            );
        } else if (['166', '167', '182', '191', '192'].includes(this.response?.errorResponse?.errorCode)) {
            this.gtmService.raiseEventForAffordabilityButtons(
                this.labelEvnt,
                'increase limit cta',
                this.positionEvnt,
                this.response?.errorResponse?.increaseLimitsUrl,
                this.response?.errorResponse?.playerLevel,
                this.response?.errorResponse?.additionalData?.AffAgeGroup,
                this.limitType,
                this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
            );
        } else {
            this.gtmService.raiseEventForAffordabilityButtons(
                'request higher limit',
                'increase limit cta',
                'user at ' + Number(this.affordibilityHardStopLimitErrorDetails?.limit) / 1000 + 'k hardstop',
                this.affordibilityHardStopLimitErrorDetails?.increaseLimitsUrl,
                this.affordibilityHardStopLimitErrorDetails?.playerLevel,
                this.affordibilityHardStopLimitErrorDetails?.additionalData?.AffAgeGroup,
                this.limitType,
                this.affordibilityHardStopLimitErrorDetails?.additionalData?.AffEmploymentGroup,
            );
            const url = this.affordibilityHardStopLimitErrorDetails?.increaseLimitsUrl + '&output=embed';
            this.navigateTo(url);
        }
    }
    checkMyLimits() {
        if (
            [
                ErrorCode.AffordibilityGrossDepositLimitsExceeded_178,
                ErrorCode.AffordibilityGrossDepositLimitsExceeded_177,
                '191',
                '192',
                '185',
                '186',
                '183',
                '186',
                '193',
                '194',
            ].includes(this.response?.errorResponse?.errorCode)
        ) {
            this.gtmService.raiseEventForAffordabilityButtons(
                this.labelEvnt,
                'check my limits cta',
                this.positionEvnt,
                this.response?.errorResponse?.increaseLimitsUrl,
                this.response?.errorResponse?.playerLevel,
                this.response?.errorResponse?.additionalData?.AffAgeGroup,
                this.limitType,
                this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
            );
        }
        if (this.response?.errorResponse?.errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_177) {
            this.gtmService.raiseEventForAffordabilityButtons(
                'request higher limit',
                'check my limits cta',
                'gdl aff monthly limit',
                this.affordibilityMonthlyGrossDepLimitErrorDetails?.increaseLimitsUrl,
                this.affordibilityMonthlyGrossDepLimitErrorDetails?.playerLevel,
                this.affordibilityMonthlyGrossDepLimitErrorDetails?.additionalData?.AffAgeGroup,
                this.limitType,
                this.affordibilityMonthlyGrossDepLimitErrorDetails?.additionalData?.AffEmploymentGroup,
            );
        }
        if (['166', '167', '182', '185', '186', '191'].includes(this.response?.errorResponse?.errorCode)) {
            this.gtmService.raiseEventForAffordabilityButtons(
                this.labelEvnt,
                'check my limits cta',
                this.positionEvnt,
                this.response?.errorResponse?.increaseLimitsUrl,
                this.response?.errorResponse?.playerLevel,
                this.response?.errorResponse?.additionalData?.AffAgeGroup,
                this.limitType,
                this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
            );
        }
    }
    navigateTo(url: string) {
        this.navigationService.goTo(url, { forceReloadTarget: 'top' });
    }
    lossLimitLink(event: any, linkName: any) {
        if (event?.target?.tagName?.toLowerCase() == 'a') {
            if (this.response?.errorResponse?.errorCode === ErrorCode.MaxLossLimitMonthlyExceeded_184) {
                const isExceeded = this.response?.errorResponse?.errorMessage == 'MAX_LOSS_LIMIT_MONTHLY_EXCEEDED' ? true : false;
                this.gtmService.raiseEventForMaxLossLimitClick(
                    isExceeded,
                    linkName,
                    this.maxLossLimitMonthlyExceededErrorDetails?.increaseLimitsUrl,
                    this.response?.errorResponse?.additionalData?.AffAgeGroup,
                    'max loss limit ltm',
                    this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
                    this.response?.errorResponse?.playerLevel,
                );
            }
            if (['191', '192'].includes(this.response?.errorResponse?.errorCode)) {
                this.gtmService.raiseEventForAffordabilityButtons(
                    this.labelEvnt,
                    linkName ? linkName : event.target.innerHTML?.toLowerCase() + ' link',
                    this.positionEvnt,
                    this.rolling30dayLossLimitDetails?.lossLimitFaqLink,
                    this.rolling30dayLossLimitDetails?.playerLevel,
                    this.rolling30dayLossLimitDetails?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.rolling30dayLossLimitDetails?.additionalData?.AffEmploymentGroup,
                );
            }
            if (this.response?.errorResponse?.errorCode === ErrorCode.AffordabilityMaxLossLimitsuggestion) {
                this.gtmService.raiseEventForAffordabilityButtons(
                    this.labelEvnt,
                    linkName,
                    this.positionEvnt,
                    this.affMaxLossLimitSuggestionErrorDetails?.sgqLink,
                    this.affMaxLossLimitSuggestionErrorDetails?.playerLevel,
                    this.affMaxLossLimitSuggestionErrorDetails?.additionalData?.AffAgeGroup,
                    this.limitType,
                    this.affMaxLossLimitSuggestionErrorDetails?.additionalData?.AffEmploymentGroup,
                );
            }
        }
    }

    startButtonClick() {
        if (this.response?.errorResponse?.errorCode === ErrorCode.AffordibilityGrossDepositLimitsExceeded_179) {
            this.gtmService.raiseEventForAffordabilityButtons(
                'affordability questionnaire',
                'start cta',
                'user at ' + Number(this.response?.errorResponse?.limit) / 1000 + 'k gdl mile stone',
                this.affordibilityMilestoneSgqGrossLimitErrorDetails?.sgqLink,
                this.affordibilityMilestoneSgqGrossLimitErrorDetails?.playerLevel,
                this.affordibilityMilestoneSgqGrossLimitErrorDetails?.additionalData?.AffAgeGroup,
                this.limitType,
                this.affordibilityMilestoneSgqGrossLimitErrorDetails?.additionalData?.AffEmploymentGroup,
            );
            const url = this.affordibilityMilestoneSgqGrossLimitErrorDetails?.sgqLink + '&output=embed';
            this.navigateTo(url);
        } else if (['195', '196', '197'].includes(this.response?.errorResponse?.errorCode)) {
            this.gtmService.raiseEventForAffFRAMsgBannerLoadClick(
                this.labelEvnt,
                'click',
                this.positionEvnt,
                'start questionnaire cta',
                this.response?.errorResponse?.selfCertLink,
                this.response?.errorResponse?.playerLevel,
                this.response?.errorResponse?.additionalData?.AffAgeGroup,
                this.limitType,
                this.response?.errorResponse?.additionalData?.AffEmploymentGroup,
            );
        } else if (this.response?.errorResponse?.errorCode == ErrorCode.AffordibilityNetDepositLimitsExceeded_175) {
            this.gtmService.raiseEventForAffordabilityButtons(
                'affordability questionnaire',
                'start cta',
                'user at ' + Number(this.affordibility3kMilestoneLimitErrorDetails?.limit) / 1000 + 'k milestone',
                this.affordibility3kMilestoneLimitErrorDetails?.sgqLink,
                this.affordibility3kMilestoneLimitErrorDetails?.playerLevel,
                this.affordibility3kMilestoneLimitErrorDetails?.additionalData?.AffAgeGroup,
                this.limitType,
                this.affordibility3kMilestoneLimitErrorDetails?.additionalData?.AffEmploymentGroup,
            );
            const url = this.affordibilityMilestoneSgqGrossLimitErrorDetails?.sgqLink + '&output=embed';
            this.navigateTo(url);
        } else if (['185', '186'].includes(this.response?.errorResponse?.errorCode)) {
            this.gtmService.raiseEventForAffordabilityButtons(
                this.labelEvnt,
                'start cta',
                this.positionEvnt,
                this.affordabilityQuestionaireLimit?.sgqLink,
                this.affordabilityQuestionaireLimit?.playerLevel,
                this.affordabilityQuestionaireLimit?.additionalData?.AffAgeGroup,
                this.limitType,
                this.affordabilityQuestionaireLimit?.additionalData?.AffEmploymentGroup,
            );
        }
    }

    continueButton() {
        this.gtmService.raiseEventForAffordabilityButtons(
            'self certification',
            'continue cta',
            Number(this.affordibility8kMilestoneLimitErrorDetails?.limit) / 1000 + 'k milestone',
            this.affordibility8kMilestoneLimitErrorDetails?.selfCertLink,
            this.affordibility8kMilestoneLimitErrorDetails?.playerLevel,
            this.affordibility8kMilestoneLimitErrorDetails?.additionalData?.AffAgeGroup,
            this.limitType,
            this.affordibility8kMilestoneLimitErrorDetails?.additionalData?.AffEmploymentGroup,
        );
        const url = this.affordibility8kMilestoneLimitErrorDetails?.selfCertLink + '&output=embed';
        this.navigateTo(url);
    }

    startQuestionnaire() {
        if (
            [ErrorCode.AffordibilityGrossDepositLimitsExceeded_180, ErrorCode.AffordibilityNetDepositLimitsExceeded_176].includes(
                this.response?.errorResponse?.errorCode,
            )
        ) {
            this.gtmService.raiseEventForAffordabilityButtons(
                this.labelEvnt,
                'start questionnaire cta',
                this.positionEvnt,
                this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.selfCertLink,
                this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.playerLevel,
                this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.additionalData?.AffAgeGroup,
                this.limitType,
                this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.additionalData?.AffEmploymentGroup,
            );
        }
        this.navigateTo(this.affordibilityMilestoneSelfCertGrossLimitErrorDetails?.selfCertLink + '&output=embed');
    }
    moreInfoLink() {
        this.gtmService.intensivePlayerMsgClickOnMoreInfo(this.moreInfoIntensePlayerLink);
        this.navigateTo(this.moreInfoIntensePlayerLink);
    }
    liveChatUrlRisky() {
        this.gtmService.riskyPlayerClickOnLiveChat('deposit unsuccessful message', this.liveChatRiskPlayerUrl);
        this.navigateTo(this.liveChatRiskPlayerUrl);
    }
    getBehaviorData() {
        this.subscriptions$.push(
            this.behaviorData.getSportsLimitsErrorDetails.subscribe((data) => {
                if (!data) {
                    this.sportsLimitsErrorDetails = data;
                    this.resizeService.resizeCashier();
                }
            }),
        );
        this.subscriptions$.push(
            this.behaviorData.getGamingLimitsErrorDetails.subscribe((data) => {
                if (!data) {
                    this.gamingLimitsErrorDetails = data;
                    this.resizeService.resizeCashier();
                }
            }),
        );
    }
    setFrequency(errorCode: any) {
        switch (errorCode) {
            case '701':
            case '702':
                this.frequency = '24-hour';
                break;
            case '707':
            case '703':
                this.frequency = '7-day';
                break;
            case '708':
            case '704':
                this.frequency = '30-day';
                break;
            default:
                this.frequency = 'lifetime';
                break;
        }
    }

    getErrorMessage(errorCode = 'DEFAULT') {
        const property = INTERCHECKS_ACH_ERROR_CODES[errorCode] || INTERCHECKS_ACH_ERROR_CODES.DEFAULT;
        return this.translate.instant(property);
    }

    ngOnDestroy() {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
